import { SubTopic } from '../../../../_models/subTopic';


import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { SubTopicService } from 'src/app/_services/subTopic.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import Swal from 'sweetalert2';
import { AdminService } from '../../../../_services/admin.service';

@Component({
  selector: 'app-admin-syllabus-subtopic-addtemplate',
  templateUrl: './admin-syllabus-subtopic-addtemplate.component.html',
  styleUrls: ['./admin-syllabus-subtopic-addtemplate.component.css']
})
export class AdminSyllabusSubtopicAddTemplateComponent implements OnInit {
  templateList=[]
  subTopicTemplateList=[]
  server_subtopic_id=0
  subTopic = new SubTopic()
  searchTemplateForm:FormGroup
  constructor(
    private adminService:AdminService,
    private activatedRoute:ActivatedRoute,
    private syllabusService:SyllabusService,
    private subTopicService: SubTopicService
  ) {

  }

  ngOnInit(): void {
    this.initForm()
    this.onChanges()
    this.activatedRoute.params.subscribe(
      params=>{
        this.server_subtopic_id= +params['server_subtopic_id']
        this.subTopicService.getSubTopicById(this.server_subtopic_id).subscribe({
          next:(data:ResultData)=>{
            this.subTopic=data.rs.data
          }
        }

        )
      }
    )
  }

  initForm(){
   this.searchTemplateForm= new FormGroup(
      {'searchInput': new FormControl('')}
      )
  }

  onChanges(): void {
    this.searchTemplateForm.get('searchInput').valueChanges.subscribe(val => {
      if(val.length>2){

        this.adminService.searchTemplatesBySubTopics(val,this.subTopic.server_subtopic_id).subscribe({
          next:(data:ResultData)=>{
            this.subTopicTemplateList=data.rs.data
          }
        }

        )
    }else{
      this.subTopicTemplateList=[]
    }
  })
  // onChanges(): void {
  //   this.searchTemplateForm.get('searchInput').valueChanges.subscribe(val => {
  //     if(val.length>2){

  //       this.adminService.searchQuestionTemplate(val,this.subTopic.server_subtopic_id).subscribe(
  //         x=>{
  //           this.templateList=x
  //         }
  //       )
  //   }else{
  //     this.templateList=[]
  //   }
  // })
}

addTemplate(server_template_id:number){
  this.adminService.addTemplateToSubTopic(server_template_id,this.server_subtopic_id).subscribe({
    next:(data:ResultData)=>{
      this.subTopic=data.rs.data
  }

  })
}

onRemoveTemplate(questionTemplateId:number){
    Swal.fire({
      title:'Oops',
      text: 'Are you sure you want to remove this template from this topic?',
      showCancelButton: true,
      confirmButtonText: 'Yes, Removed it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
        if (result.value) {
          this.doRemoveTemplate(questionTemplateId)
          Swal.fire(
            'Removed!',
            'Your template has been removed.',
            'success'
          )

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Ok :)',
            'error'
          )
        }
      })
  }

  doRemoveTemplate(questionTemplateId:number){
    this.syllabusService.removeQuestionTemplate(this.subTopic.server_subtopic_id,questionTemplateId).subscribe({
      next:(data:ResultData)=>{
        this.subTopic=data.rs.data
      }
    }
    )
  }
}
